import { Controller } from 'stimulus'

export default class extends Controller {
  scrollToHeader(event) {
    const id = $(event.currentTarget).data('id')
    window.animating = true
    $('html, body').animate(
      {
        scrollTop: $(`#header-${id}`).offset().top - 180,
      },
      700,
      function () {
        window.animating = false
      }
    )
  }
}
